import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    height: theme.spacing(4),
    background: theme.palette.bgV2.main,
    alignItems: 'center',
    borderRadius: theme.spacing(0.5),
    paddingLeft: theme.spacing(1),
  },
  image: {
    display: 'flex',
    width: theme.spacing(2.5),
    height: theme.spacing(2.5),
    justifyContent: 'center',
    alignItems: 'flex-end',
    objectFit: 'contain',
    marginTop: theme.spacing(0.375),
  },
  linkText: {
    fontSize: '11px !important',
    lineHeight: '16px !important', //important needed to overwride css
  },
}))
